import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import { useContext } from '../Context';
import Form from '../Form/Index';

export default function NewModal({ show, onHide }) {
  const { dispatch, actions } = useContext();

  const onSave = (formData, successCallback, errorCallback) => {
    actions.create(
      dispatch,
      formData,
      () => {
        swal('Affiliate Training Step Created');
        successCallback();
      },
      errorCallback,
    );
  };

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>Create Affiliate Training Step</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSave={onSave} onHide={onHide} />
      </Modal.Body>
    </Modal>
  );
}

NewModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
